import { render, staticRenderFns } from "./chart06.vue?vue&type=template&id=577a8be6"
import script from "./chart06.vue?vue&type=script&lang=js"
export * from "./chart06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports